/* unplugin-vue-components disabled */import script from "./RechargeRuleRewardPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeRuleRewardPopup.vue?vue&type=script&setup=true&lang=js"

import "./RechargeRuleRewardPopup.vue?vue&type=style&index=0&id=49a12738&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a12738"]])

export default __exports__